import Consts from '@/common/consts'
export default {
  GET_SHORT_URL: `${Consts.API_HOST_SHORTURL}/shorturl`, // 长链接转短链接接口
  LOAD_WX_SHARE: `${Consts.API_HOST_WX}/getJsSdkSign/7`, // 微信分享--获取签名
  GET_SHARE_POSTER: `${Consts.API_HOST_WX}/pub/goodsPoster`, // 获取分享海报
}
